import React, {
  Fragment,
} from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Row,
} from 'antd';
import { DoubleRightOutlined } from '@ant-design/icons';
import { TableView } from 'components';
import { connect } from 'dva';
import { controllerShareRules } from 'controller';

const { Option } = Select;

class ShareRulesManage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showForm: false,
      shareDataTypes: [],
      searchObj: {
        code: '',
        sharingType: '',
        count: 10,
        name: '',
        page: 1,
      },
      list: [],
      total: 0,
    };
    this.setRule = this.setRule.bind(this);
    this.getData = this.getData.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const timer = window.setInterval(() => {
      if (this.props.loginInfo.userId) {
        clearInterval(timer);
        this.getData();
        controllerShareRules.getSharingData().then(res => {
          if (res.code === __SUCCESS__) {
            this.setState({shareDataTypes: res.data || []})
          } else {
            console.error(res.msg);
          }
        });
      }
    }, 100);
  }

  handleClick() {
    this.setState({showForm: !this.state.showForm})
  }

  onSearch(values) {
    this.setState({ searchObj: { ...this.state.searchObj, ...values, page: 1 } }, () => {
      this.getData();
    });
  }

  resetSearch() {
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        code: '',
        name: '',
        page: 1,
      },
    }, () => {
      this.getData();
      this.formEl.setFieldsValue({code: '', name: ''});
    });
  }
  pageChange(page, pageSize) {
    this.setState({ searchObj: { ...this.state.searchObj, count: pageSize, page: page } }, () => {
      this.getData();
    });
  }

  getData() {
    const { searchObj } = this.state;
    this.setState({ loading: true });
    controllerShareRules.getSharingList(searchObj).then(res => {
      this.setState({ loading: false });
      if (res.code === __SUCCESS__) {
        this.setState({ total: res.total, list: res.data });
      } else {
        console.error(res.msg);
      }
    });
  }

  setRule(data) {
    controllerShareRules.setSharing({ sharingId: data.id, status: data.status === '1' ? '0' : '1' }).then(res => {
      this.setState({ loading: false });
      if (res.code === __SUCCESS__) {
        this.getData();
      } else {
        console.error(res.msg);
      }
    });
  }

  render() {
    const { searchObj, total, loading, list, shareDataTypes, showForm } = this.state;
    const tableProps = {
      rowKey: 'id',
      loading,
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: '规则名称',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '共享数据',
          dataIndex: 'sharingTypeName',
          key: 'sharingTypeName',
        },
        {
          title: '数据共享来源',
          dataIndex: 'sharingSource',
          key: 'sharingSource',
        },
        {
          title: '数据共享至',
          dataIndex: 'sharingTo',
          key: 'sharingTo',
        },
        {
          title: '共享权限',
          dataIndex: 'powerStr',
          key: 'powerStr',
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          render: (val) => (val === '1' ? '启用中' : '已停用'),
        },
        {
          title: '操作',
          width: 160,
          align: 'center',
          render: (val, record, index) => <Fragment>
            <Button type="link" href={`#shareRulesManage/${record.id}`}>查看</Button>
            <Button type="link" onClick={() => this.setRule(record)}>{record.status === '1' ? '停用' : '启用'}</Button>
          </Fragment>,
        },
      ],
      rows: list,
      pageParam: {
        total: total,
        current: searchObj.page,//当前页码
        pageSize: searchObj.count,//当前分页数
        onChange: this.pageChange,
      },
    };
    return <Fragment>
      <div className="app-body">
        <PageHeader
          ghost={false}
          className="gray-header"
          title={<Button type="gray" href="#shareRulesManage/0">新增共享规则</Button>}
          extra={[
            <Button className="pos-bottom" key="1" onClick={this.handleClick} icon={<DoubleRightOutlined rotate={90} />}>展开查询</Button>,
          ]}
        />

        <Form
          name="basic"
          className="top-search-box"
          ref={node => this.formEl = node}
          style={{display: showForm ? 'block' : 'none'}}
          initialValues={{
            sharingType: searchObj.sharingType,
            name: searchObj.name,
          }}
          onFinish={this.onSearch}
        >
          <Row gutter={8}>
            <Col span={8}>
              <Form.Item
                label="规则名称"
                name="name"
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="共享数据"
                name="sharingType"
              >
                <Select placeholder="请选择共享的数据">
                  {shareDataTypes.map(x => <Option key={x.code} value={x.code}>{x.name}</Option>)}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Button type="danger" htmlType="submit">
                搜索
              </Button>
              &emsp;
              <Button onClick={this.resetSearch} style={{ margin: '0 8px' }}>
                重置
              </Button>
            </Col>
          </Row>
        </Form>
        <div className="page-main-box">
          <TableView {...tableProps} />
        </div>
      </div>
    </Fragment>;
  }
}

ShareRulesManage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  loginInfo: PropTypes.object,
};
export default connect(({ shareRulesManage }) => shareRulesManage)(ShareRulesManage);
